export const centerGameObjects = (objects) => {
  objects.forEach(function(object) {
    object.anchor.setTo(0.5)
  })
}



// WEBPACK FOOTER //
// ./src/game/utils.js